export const RateCalcSrcAddress = { key: 'srcAddress', label: 'Source Address' };
export const RateCalcDstAddress = { key: 'dstAddress', label: 'Destination Address' };

export const ADDRESS_SUB_FIELD_LABELS: Record<string, string> = {
    name: 'Name',
    companyName: 'Company Name',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    pincode: 'Pincode',
    cityName: 'City',
    stateName: 'State',
    countryName: 'Country',
    phone: 'Phone',
    alternatePhone: 'Alternate Phone',
    email: 'Email',
    locationId: 'Location ID',
    locationCode: 'Location Code',
};

// Used as fallback when /fetchRateCalculatorFormConfig returns no data or is unavailable.
// Field keys must match entries in generic-field-renderer.tsx mapping:
//   'srcAddress' / 'dstAddress' → SimpleAddressField (intercepted by getRateCalcField)
//   'weight'                    → WeightField        (Weight.key)
//   'weightUnit'                → WeightUnit select  (WeightUnit.key)
//   'dimensions'                → DimensionsField    (bundles length, width, height, unit internally)
//   'courierType'               → ItemTypeField      (ItemType.key — Document / Non-Document radio)
export const DEFAULT_RATE_CALC_FORM_CONFIG = {
    is_enabled: true,
    form_layout: [
        'srcAddress',
        'dstAddress',
        'weight',
        'dimensions',
        'courierType',
    ],
    sub_layout: {
        srcAddress: ['countryName', 'stateName', 'cityName', 'pincode'],
        dstAddress: ['countryName', 'stateName', 'cityName', 'pincode'],
    },
};
